import { parseDate } from 'src/utils/parseDate';

export const formatFullDateTime = (date?) => parseDate(date).format('YYYY-MM-DD HH:mm:ss');

export const formatLongDateTime = (date?) => parseDate(date).format('YYYY-MM-DD HH:mm');

export const formatDate = (date?) => parseDate(date).format('YYYY-MM-DD');

export const formatTime = (time?) => parseDate(time).format('HH:mm');
